import { useEffect, useRef, useState } from 'react';

// How long the pane keeps its scrollbar after the last scroll event.
const IDLE_MS = 600;

/**
 * True while the element scrolls, false once it stops.
 *
 * A scrollbar that is always painted reads as a second page scrollbar beside
 * the article pane. CSS cannot see a scroll in progress, so the scroll
 * handler reports it and an idle timer clears it.
 */
export const useScrollActivity = () => {
  const [isScrolling, setIsScrolling] = useState(false);
  const idleTimer = useRef(0);

  const onScroll = () => {
    setIsScrolling(true);
    window.clearTimeout(idleTimer.current);
    idleTimer.current = window.setTimeout(() => setIsScrolling(false), IDLE_MS);
  };

  useEffect(() => () => window.clearTimeout(idleTimer.current), []);

  return { isScrolling, onScroll };
};
